import React, { useEffect, useState } from 'react';
import { Container, Grid, makeStyles } from '@material-ui/core';
import { IdeaEditGeneral } from "./../../components/IdeaEdit/IdeaEditGeneral"
import { IdeaEditGeneralImage } from "./../../components/IdeaEdit/IdeaEditGeneralImage"
import { IdeaEditGeneralVideo } from "./../../components/IdeaEdit/IdeaEditGeneralVideo"
import { IdeaEditGeneralDocs } from "./../../components/IdeaEdit/IdeaEditGeneralDocs"
import { IdeaEditGeneralBusinessCanvas } from "./../../components/IdeaEdit/IdeaEditGeneralBusinessCanvas"
import { IdeaEditGeneralValueCanvas } from "./../../components/IdeaEdit/IdeaEditGeneralValueCanvas"
import { IdeaEditGeneralLinks } from "./../../components/IdeaEdit/IdeaEditGeneralLinks"
import { IdeaEditGeneralParticipants } from "./../../components/IdeaEdit/IdeaEditGeneralParticipants"
import { IdeaEditGeneralCoverage } from "./../../components/IdeaEdit/IdeaEditGeneralCoverage"
import { IdeaEditActions } from "./../../components/IdeaEdit/IdeaEditActions"
import { BackNavAdmin } from "../../components/Shared/BackNavAdmin"
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { domainsActions, ideaUpdateActions } from '../../actions';
import { history } from '../../helpers';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 14,
    },
  },
  container: {
    paddingLeft: 16,
    justifyContent: 'center'
  },
  btnContainer: {
    width: '92%',
    display: 'flex',
    justifyContent: 'end',
  }
}));

export function IdeaEditPage() {
  const classes = useStyles();
  const { ideaUpdate, user } = useSelector((state) => state);
  const dispatch = useDispatch();
  const { id } = useParams();
  const [ownerIdea, setOwnerIdea] = useState(false);
  const { ideaFailed } = useSelector(state => state.ideaUpdate)

  useEffect(() => {
    dispatch(domainsActions.getDomains());
    dispatch(ideaUpdateActions.getIdeaDetails(id, 'general'));
  }, [dispatch, id]);

  useEffect(() => {
    if(!!ideaUpdate.user?._id?.length && !!user._id?.length) {
      ideaUpdate.user?._id !== user._id ? history.push('/') : setOwnerIdea(true);
    }
  }, [ideaUpdate, user]);

  useEffect(() => {
    if (ideaFailed) {
      //nao existe a ideia
      history.goBack()
    }
  }, [ideaFailed])

  useEffect(() => {
    return () => dispatch(ideaUpdateActions.clearIdeaDetails());
  }, [dispatch])

  return (
    ownerIdea && (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <BackNavAdmin title={ideaUpdate?.name} />
        </Grid>
        <Grid item xs={12}>
          <Container maxWidth="lg" className={classes.root}>
            <Grid container spacing={4}>
              <Grid item xs={8}>
                <Grid container spacing={4}>
                  { ideaUpdate?._id && <IdeaEditGeneral /> }
                  { ideaUpdate?._id && <IdeaEditGeneralImage /> }
                  { ideaUpdate?._id && <IdeaEditGeneralVideo /> }
                  { ideaUpdate?._id && <IdeaEditGeneralDocs /> }
                  { ideaUpdate?._id && <IdeaEditGeneralBusinessCanvas />}
                  { ideaUpdate?._id && <IdeaEditGeneralValueCanvas />}
                  { ideaUpdate?._id && <IdeaEditGeneralLinks />}
                  { ideaUpdate?._id && <IdeaEditGeneralParticipants />}
                  { ideaUpdate?._id && <IdeaEditGeneralCoverage />}
                </Grid>
              </Grid>
              <Grid item xs={4}>
                <IdeaEditActions />
              </Grid>
            </Grid>
          </Container>
        </Grid>
      </Grid>
    )
  );
}
